const DEFAULT_CATEGORY = "General";

export const FALLBACK_VIDEOS = [
  {
    id: "v1",
    title: "Intro to Living Room Inquiries",
    excerpt: "",
    tags: [],
    category: "About",
    duration: "8:19",
    status: "published",
    isFeatured: true,
    publishedDate: "2025-09-02",
    youtubeId: "VjM-IWzFqxw",
    youtubeUrl: "https://www.youtube.com/watch?v=VjM-IWzFqxw",
  },
  {
    id: "v2",
    title: "About the Founders of Living Room Inquiries",
    excerpt: "",
    tags: [],
    category: "About",
    duration: "47:50",
    status: "published",
    isFeatured: false,
    publishedDate: "2025-09-02",
    youtubeId: "Xp3ps5HFpIY",
    youtubeUrl: "https://www.youtube.com/watch?v=Xp3ps5HFpIY",
  },
];

export function extractYouTubeId(input) {
  if (!input || typeof input !== "string") return "";

  const trimmed = input.trim();
  if (!trimmed) return "";

  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) return trimmed;

  try {
    const url = new URL(trimmed);
    const host = url.hostname.replace(/^www\./, "");

    if (host === "youtu.be") {
      const pathId = url.pathname.split("/").filter(Boolean)[0];
      return /^[a-zA-Z0-9_-]{11}$/.test(pathId) ? pathId : "";
    }

    if (
      host === "youtube.com" ||
      host === "m.youtube.com" ||
      host === "music.youtube.com" ||
      host === "youtube-nocookie.com"
    ) {
      const fromQuery = url.searchParams.get("v");
      if (/^[a-zA-Z0-9_-]{11}$/.test(fromQuery || "")) return fromQuery;

      const parts = url.pathname.split("/").filter(Boolean);
      const candidate = parts[1] || parts[0] || "";
      return /^[a-zA-Z0-9_-]{11}$/.test(candidate) ? candidate : "";
    }
  } catch {
    return "";
  }

  return "";
}

export function buildYouTubeThumbnail(youtubeId) {
  if (!youtubeId) return "";
  return `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;
}

function normalizeTags(tags) {
  if (!Array.isArray(tags)) return [];
  return tags
    .map((tag) => String(tag || "").trim())
    .filter(Boolean)
    .filter((tag, idx, arr) => arr.findIndex((t) => t.toLowerCase() === tag.toLowerCase()) === idx);
}

function normalizeDate(rawDate) {
  if (!rawDate) return "";
  const date = new Date(rawDate);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
}

export function normalizeVideo(raw) {
  const youtubeId = extractYouTubeId(raw?.youtubeId || raw?.youtubeUrl || raw?.url || "");
  const publishedDate = normalizeDate(raw?.publishedDate || raw?.date);
  const title = String(raw?.title || "").trim() || "Untitled Video";

  return {
    id: raw?.id || raw?._id || `${youtubeId || "video"}-${Date.now()}`,
    title,
    excerpt: String(raw?.excerpt || "").trim(),
    tags: normalizeTags(raw?.tags),
    category: String(raw?.category || "").trim() || DEFAULT_CATEGORY,
    duration: String(raw?.duration || "").trim(),
    status: String(raw?.status || "draft").trim() || "draft",
    isFeatured: !!raw?.isFeatured,
    publishedDate,
    date: publishedDate,
    youtubeId,
    youtubeUrl: String(raw?.youtubeUrl || "").trim(),
    src: String(raw?.src || "").trim(),
    thumb:
      String(raw?.thumbnailUrl || "").trim() ||
      String(raw?.thumb || "").trim() ||
      buildYouTubeThumbnail(youtubeId),
  };
}

export function toPublishedVideos(videos) {
  return (Array.isArray(videos) ? videos : [])
    .map((v) => normalizeVideo(v))
    .filter((v) => v.status === "published" && !!v.youtubeId);
}

export function getVideoCategories(videos) {
  const categories = new Set();
  (Array.isArray(videos) ? videos : []).forEach((video) => {
    const category = String(video?.category || "").trim();
    if (category) categories.add(category);
  });
  return ["All", ...categories];
}
